import { PostUtil } from 'src/pages/new-post-new/post-util';
import LinkedinPostImagesPreview from './linkedin-post-images-preview.component';
import LinkedinPostVideoPreview from './linkedin-post-video-preview.component';

const LinkedinPostPreview = ({ data }) => {
  const isVideo = data?.media_data?.count === 1 && data?.media_data.media_data[0].type === PostUtil.MediaType.VIDEO;
  return <>{isVideo ? <LinkedinPostVideoPreview data={data} /> : <LinkedinPostImagesPreview data={data} />}</>;
};

export default LinkedinPostPreview;
